import { CapitalEarningLeverage } from './capitalEarningLeverage'
import { FundingLiquidity } from './fundingLiquidity'

export const Securities = ({ settingsFS }) => {
  return (
    <>
      <CapitalEarningLeverage settingsFS={settingsFS} />
      <FundingLiquidity settingsFS={settingsFS} />
    </>
  )
}
